module.exports = __webpack_public_path__ + "710970dee44ef96a8200c60213ea22f0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/about-hero-ben.png
// module id = 116
// module chunks = 0